import { InventoryDistrict } from './inventoryDistrict';

export class InventoryCity {
    id: string;
    name: string;
    district: InventoryDistrict = new InventoryDistrict();
}